const camelToSpace = (text: string): string => {
  return text.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => {
    return str.toUpperCase();
  });
};

export { camelToSpace };
